import { Auth0Provider } from '@auth0/auth0-react'
import { ChakraProvider } from '@chakra-ui/react'
import { createRoot } from 'react-dom/client'
import { Provider } from 'react-redux'

// ** Spinner (Splash Screen)

// ** Core styles
import './@core/assets/fonts/feather/iconfont.css'
import './@core/scss/core.scss'
import './assets/scss/style.scss'
import './index.css'

// OLD PROJECT IMPORTS
import ReduxToastr from 'react-redux-toastr'
import { BrowserRouter } from 'react-router-dom'
import { ToastContainer } from 'react-toastify'

import App from './App'
import { mfAdminChakraTheme } from './configs/mfChakraTheme'
import {
  REACT_APP_AUTH0_DOMAIN,
  REACT_APP_AUTH0_CLIENT_ID,
  REACT_APP_AUTH0_REDIRECT_URI,
  TOASTR_TIMEOUT
} from './Constants'
import { MFAdminAppInitializerProvider } from './contexts/MFAdminAppInitializer'
import { store } from './redux/storeConfig/store'
import { ThemeContext } from './utility/context/ThemeColors'

if (module.hot) {
  module.hot.accept()
}

const auth0Domain = REACT_APP_AUTH0_DOMAIN
const auth0ClientId = REACT_APP_AUTH0_CLIENT_ID
const auth0RedirectUri = REACT_APP_AUTH0_REDIRECT_URI

const appRootContainer = document.getElementById('root')
const root = createRoot(appRootContainer)

root.render(
  <BrowserRouter basename="/">
    <ChakraProvider theme={mfAdminChakraTheme}>
      <MFAdminAppInitializerProvider>
        <Provider store={store}>
          <Auth0Provider
            domain={auth0Domain}
            clientId={auth0ClientId}
            authorizationParams={{
              redirect_uri: auth0RedirectUri
            }}
          >
            <ReduxToastr
              timeOut={TOASTR_TIMEOUT}
              newestOnTop={false}
              preventDuplicates
              position="top-center"
              transitionIn="fadeIn"
              transitionOut="fadeOut"
              progressBar
              closeOnToastrClick
            />
            <ThemeContext>
              <App />
              <ToastContainer newestOnTop />
            </ThemeContext>
          </Auth0Provider>
        </Provider>
      </MFAdminAppInitializerProvider>
    </ChakraProvider>
  </BrowserRouter>
)
